/**
 * @readonly
 * @enum {string}
 */
export const EbpmsSummaryStatus = Object.freeze({
    FAIL: 'FAIL',
    GATHERING_DATA: 'GATHERING_DATA',
    NO_DATA: 'NO_DATA',
    PASS: 'PASS'
})
